module.exports = __webpack_public_path__ + "6200876558bce3ab9f9dc8ce30cb2b54.png";